<template>
  <div class="res_box">
    <p class="back_box" @click="back()">
      <img src="../../../static/images/back.png" alt="" />
      {{ langtrans().fhssyy[languageIndex] }}
    </p>
    <h2>{{ langtrans().ksjy[languageIndex] }}</h2>
    <div class="step_box" v-if="!loading">
      <p>
        <b>{{ langtrans().ajxq[languageIndex] }}</b>
      </p>
      <div class="newText">
        <span>{{ langtrans().khxm[languageIndex] }}：</span
        >{{ detailData.victimList[0].obj.victimName }} &nbsp;
        <span>{{ langtrans().ajh[languageIndex] }}：</span
        >{{ detailData.obj.caseNo }}
      </div>

      <Parinf :caseid="caseid" :token="token" />

      <p>
        <b>{{ langtrans().lcsy[languageIndex] }}</b>
      </p>
      <process
        :serviceLst="stepdata.slice(1, stepdata.length)"
        :serviceIndex="stid"
        :isStartRescue="true"
      ></process>
      <div class="det_box">
        <p v-for="(v, ind) in stepdata" :key="ind" v-if="v.dict.parentId === 0">
          <b>{{ languageIndex == 0 ? v.dict.name : v.dict.nameEn }}</b>
        </p>
      </div>

      <div class="jiedianBox">
        <div class="list" v-for="(item, index) in stepdata" v-if="index != 0">
          <div class="no" v-if="item.obj.state != 1">
            <div class="top">
              <p class="iconNo">
                {{ languageIndex == 0 ? item.dict.name : item.dict.nameEn }}
              </p>
              <p class="text1" @click="st(index)">
                {{ langtrans().kscczz[languageIndex] }}
              </p>
              <p class="text1" @click="morenode1(index)">
                {{ langtrans().qtjdjl[languageIndex] }}
              </p>
            </div>
            <div class="box1" v-if="item.solutionSvrPointList">
              <p>{{ langtrans().qjtjjd[languageIndex] }}</p>
              <ul>
                <li
                  v-for="(item, index) in item.solutionSvrPointList"
                  v-if="item.description != ''"
                >
                  {{ index + 1 }}、{{
                    languageIndex == 0
                      ? setTxt(item.description, "zh")
                      : setTxt(item.description, "en")
                  }}
                </li>
              </ul>
            </div>
          </div>
          <div class="yes" v-else>
            <div class="top">
              <p class="icon">
                {{ languageIndex == 0 ? item.dict.name : item.dict.nameEn }}
              </p>
              <p
                class="text1"
                @click="
                  st1(index);
                  setSuji();
                "
              >
                {{ langtrans().xgssym[languageIndex] }}
              </p>
              <p
                class="text1"
                @click="
                  morenode1(index);
                  setSuji();
                "
              >
                {{ langtrans().xgjj[languageIndex] }}
              </p>
            </div>
            <div class="box1">
              <p>{{ langtrans().qjtjjd[languageIndex] }}</p>
              <ul>
                <li
                  v-for="(item, index) in item.solutionSvrPointList"
                  v-if="item.description != ''"
                >
                  {{ index + 1 }}、{{
                    languageIndex == 0
                      ? setTxt(item.description, "zh")
                      : setTxt(item.description, "en")
                  }}
                </li>
              </ul>
            </div>
            <div class="box1">
              <p>{{ langtrans().cczzzs[languageIndex] }}</p>
              <ul>
                <li>
                  {{
                    languageIndex == 0
                      ? setTxt(item.obj.description, "zh")
                      : setTxt(item.obj.description, "en")
                  }}
                </li>
              </ul>
            </div>
            <div class="box1">
              <p>{{ langtrans().xxgdcs[languageIndex] }}</p>
              <ul class="addfujian">
                <li v-for="item in imglist[index - 1].list" v-if="item.url">
                  <span>{{ item.description || "no name" }}</span>
                  <a
                    :href="item.url"
                    class="delete"
                    :download="item.url"
                    target="_blank"
                    >[{{ langtrans().xzz[languageIndex] }}]</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p class="p acc">
        <el-button center type="primary" @click="acc()">{{
          langtrans().jywc[languageIndex]
        }}</el-button>
      </p>
    </div>
    <el-dialog
      :title="langtrans().ajcczz[languageIndex]"
      :visible.sync="centerDialogVisible"
      width="750px"
      center
    >
      <div class="c_box">
        <p style="font-weight: 600; margin-bottom: 10px">
          {{ langtrans().tjcczz[languageIndex] }}
        </p>
        <!-- <el-input rows="3" type="textarea" :placeholder="langtrans().cczzzj[languageIndex]" v-model="txt" @input="txtdata"></el-input> -->
        <changeLanguage v-model="txt" :changeText="txt"></changeLanguage>
      </div>
      <div class="i_box">
        <p style="font-weight: 600">{{ langtrans().xxgdcs[languageIndex] }}</p>
        <ul class="addfujian">
          <li>
            <a class="delete" @click="upimg()">{{
              langtrans().tjfj[languageIndex]
            }}</a>
          </li>
          <li v-for="(item, index) in urllist" :key="index">
            <span>{{ item.description || "no name" }}</span>
            <a class="delete" @click="urllist.splice(index, 1)"
              >[{{ langtrans().sc[languageIndex] }}]</a
            >
          </li>
        </ul>
      </div>
      <p class="p">
        <el-button center type="primary" @click="oknode()">{{
          langtrans().wcgccz[languageIndex]
        }}</el-button>
      </p>
    </el-dialog>
    <el-dialog
      :title="langtrans().fjjssy[languageIndex]"
      :visible.sync="centerDialogVisible1"
      width="50%"
      center
    >
      <div class="c_box">
        <p style="font-weight: 600; margin-bottom: 10px">
          {{ langtrans().xgcczz[languageIndex] }}
        </p>
        <!-- <el-input rows="3" type="textarea" :placeholder="langtrans().cczzzj[languageIndex]" v-model="imglistShuoming"></el-input> -->
        <changeLanguage
          :changeText="imglistShuoming"
          v-model="imglistShuoming"
          :btn="numberIndex"
        ></changeLanguage>
      </div>
      <div class="i_box">
        <p style="font-weight: 600">{{ langtrans().xxgdcs[languageIndex] }}</p>
        <ul class="addfujian">
          <li>
            <a class="delete" @click="upimg1()">{{
              langtrans().tjfj[languageIndex]
            }}</a>
          </li>
          <li v-for="(item, index) in imglistFj1" v-if="item.url">
            <span>{{ item.description || "no name" }}</span>
            <a class="delete" @click="imglistFj1.splice(index, 1)"
              >[{{ langtrans().sc[languageIndex] }}]</a
            >
          </li>
        </ul>
      </div>
      <p class="p">
        <el-button center type="primary" @click="oknode1()">{{
          langtrans().wcxg[languageIndex]
        }}</el-button>
      </p>
    </el-dialog>
    <el-dialog
      :title="langtrans().ajcczz[languageIndex]"
      :visible.sync="imgVisible"
      width="50%"
      center
    >
      <p>
        <span>{{ langtrans().tppmcc[languageIndex] }}:</span>
        <el-input
          type="text"
          :placeholder="langtrans().yldcsj[languageIndex]"
          v-model="txts"
          @input="txtsdata"
        ></el-input>
      </p>
      <p>
        <span> {{ langtrans().tppddz[languageIndex] }}: </span>
        <input
          type="file"
          name="file"
          id="filebox"
          @change="filedata($event)"
        />
      </p>
      <p class="p">
        <el-button center type="primary" @click="up()">{{
          langtrans().qd[languageIndex]
        }}</el-button>
      </p>
    </el-dialog>
    <el-dialog
      :title="langtrans().ajcczz[languageIndex]"
      :visible.sync="imgVisible1"
      width="50%"
      center
    >
      <p>
        <span>{{ langtrans().tppmcc[languageIndex] }}:</span>
        <el-input
          type="text"
          :placeholder="langtrans().yldcsj[languageIndex]"
          v-model="txts"
          @input="txtsdata"
        ></el-input>
      </p>
      <p>
        <span> {{ langtrans().tppddz[languageIndex] }}: </span>
        <input
          ref="fileInput"
          type="file"
          name="file"
          id="filebox"
          @change="filedata($event)"
        />
      </p>
      <p class="p">
        <el-button center type="primary" @click="up1()">{{
          langtrans().qd[languageIndex]
        }}</el-button>
      </p>
    </el-dialog>
    <el-dialog
      class="acc_box"
      :title="langtrans().wcjyaj[languageIndex]"
      :visible.sync="isacc"
      width="1050px"
      center
    >
      <p class="text_1">
        A{{ langtrans().bjjj[languageIndex] }}
        <span class="span" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().ztbtbj[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.totalFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
        <span class="span"
          >{{ langtrans().jyfy[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.rescueFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
        <span class="span" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().ajfy[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.caseFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
        <span class="span" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().ylfy[languageIndex] }}
          <small v-if="flag"
            >{{ feedata.medicFee }} {{ feedata.currency || "USD" }}</small
          ></span
        >
      </p>
      <div class="p_box">
        <p class="text_1">B{{ langtrans().sjfy[languageIndex] }}</p>
        <label for="jy"
          >{{ langtrans().jyfy[languageIndex] }}:
          <input
            type="number"
            name="jy"
            id="jy"
            v-model="jytxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(jytxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <label for="yl" v-if="this.$route.query.typeId != 800">
          {{ langtrans().ylfy[languageIndex] }}:<input
            type="number"
            name="yl"
            id="yl"
            v-model="yltxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(yltxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <label for="aj" v-if="this.$route.query.typeId != 800">
          {{ langtrans().ajfy[languageIndex] }}:<input
            type="number"
            name="aj"
            id="aj"
            v-model="ajtxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(ajtxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <!-- <label for="aj" v-if="this.$route.query.typeId == 800">
					案件服务费用:<input type="number" name="aj" id="aj" v-model="ajtxt" :placeholder='langtrans().qsrje[languageIndex]' @input="upnum(ajtxt)">
					<span>{{feedata.currency || 'USD'}}</span>
				</label> -->
        <label for="qt" v-if="this.$route.query.typeId != 800"
          >{{ langtrans().qjtfy[languageIndex] }}:
          <input
            type="number"
            name="qt"
            id="qt"
            v-model="qttxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(qttxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
        <label for="yl" v-if="this.$route.query.typeId == 800">
          {{ langtrans().qjtfy[languageIndex] }}:<input
            type="number"
            name="yl"
            id="yl"
            v-model="yltxt"
            :placeholder="langtrans().qsrje[languageIndex]"
            @input="upnum(yltxt)"
          />
          <span>{{ feedata.currency || "USD" }}</span>
        </label>

        <label v-if="this.$route.query.typeId != 800" for="zt" class="input">
          {{ langtrans().ztbtbj[languageIndex] }}:
          <p>{{ zttxt }}</p>
          <span>{{ feedata.currency || "USD" }}</span>
        </label>
      </div>
      <!-- <el-input rows="3" type="textarea" :placeholder="langtrans().qjtfys[languageIndex]" v-model="qt" @input="setqt"></el-input> -->
      <p>其他费用说明</p>
      <changeLanguage v-model="qt" :changeText="qt"></changeLanguage>
      <p class="p">
        <el-button center type="primary" @click="accup()">{{
          langtrans().qrtdsj[languageIndex]
        }}</el-button>
      </p>
    </el-dialog>
    <el-dialog
      :title="langtrans().ajcczz[languageIndex]"
      :visible.sync="elseDialog"
      width="550px"
      center
    >
      <p class="node" v-for="(v, ind) in nodelist" :key="ind">
        <span>{{ langtrans().tjjjdd[languageIndex] }}</span>
        <el-input
          class="input_box"
          type="text"
          :placeholder="langtrans().qtjjjd[languageIndex]"
          v-model="v.description"
        ></el-input>
        <small
          class="add_span"
          v-if="ind == nodelist.length - 1"
          @click="addNode($event, ind)"
          ><span>+</span> {{ langtrans().tj[languageIndex] }}</small
        >
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="(elseDialog = false), upnode()">{{
          langtrans().wcgccz[languageIndex]
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="langtrans().xgjj[languageIndex]"
      :visible.sync="elseDialog1"
      width="550px"
      center
    >
      <p class="node" v-for="(item, index) in nodeArr">
        <span>{{ langtrans().xgjj[languageIndex] }} {{ index + 1 }}</span>
        <!-- <el-input class="input_box" type="text" :placeholder="langtrans().qtjjjd[languageIndex]" v-model="item.description"></el-input> -->
        <changeLanguage
          class="input_box"
          :changeText="item.description"
          v-model="item.description"
          :btn="numberIndex"
        ></changeLanguage>
        <small class="add_span"
          ><span @click="deleteNode(index)">
            {{ langtrans().sc[languageIndex] }}</span
          ></small
        >
      </p>
      <p class="node" v-for="(v, ind) in nodelist">
        <span
          >{{ langtrans().tjjjdd[languageIndex] }}
          {{ nodeArr.length + 1 + ind }}</span
        >
        <!-- <el-input class="input_box" type="text" :placeholder="langtrans().qtjjjd[languageIndex]" v-model="v.description"></el-input>-->
        <changeLanguage
          class="input_box"
          v-model="v.description"
          :changeText="v.description"
        ></changeLanguage>
        <small
          class="add_span"
          v-if="ind == nodelist.length - 1"
          @click="addNode($event, ind)"
          ><span>+</span> {{ langtrans().tj[languageIndex] }}</small
        >
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="upnode1()"
          >{{ langtrans().qrxg[languageIndex] }}
        </el-button>
      </span>
    </el-dialog>

    <div class="loading" v-if="loading">
      <img src="../../../static/images/loading.gif" alt="" />
    </div>
  </div>
</template>

<script>
import Parinf from "../par/Parinf.vue";
import langtrans from "./js/resstep.vue.trans.js";
import qs from "qs";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import process from "@/components/process/index1";
import { getNodeData, getCasedetail } from "@/views/axios/api.js";
import changeLanguage from "@/components/common/changeLange.vue";
export default {
  data() {
    return {
      zttxt: "0",
      yltxt: "",
      ajtxt: "",
      jytxt: "",
      qttxt: "",
      qt: "",
      nodelist: [
        {
          description: "",
          solutionSvrId: "",
        },
      ],
      loading: true,
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data")).data,
      caseid: this.$route.query.caseid,
      stepdata: [],
      urllist: [],
      txt: "",
      txts: "",
      file: "",
      fileurl: "",
      centerDialogVisible: false,
      centerDialogVisible1: false,
      imgVisible: false,
      elseDialog: false,
      id: 0,
      stid: 0,
      num: 0,
      isacc: false,
      feedata: {},
      flag: false,
      imglist: [],
      btn_flag: false,
      serviceId: 0,
      serviceFinish: 1,
      elseDialog1: false, //修改节点
      nodeArr: [], //节点数组
      imglistFj: [], //附件数组
      imglistFj1: [], //附件数组
      imglistShuoming: "", //说明
      imgVisible1: false,
      num1: "", //index修改的第几个
      detailData: {},
      numberIndex: 0,
    };
  },
  components: {
    process,
    changeLanguage,
    Parinf,
  },

  methods: {
    setSuji() {
      setTimeout(() => {
        this.numberIndex = Math.random();
      }, 400);
    },
    getdetailCase() {
      var data = {
        token: this.token,
        caseId: this.caseid,
      };
      getCasedetail(data)
        .then((res) => {
          console.log(res);
          this.detailData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    langtrans() {
      return langtrans;
    },
    upnode() {
      let nlst = this.nodelist.slice();
      if (nlst.length < 5) {
        this.axios
          .post(
            constants.domain + "rescue/case/create_svr_point",
            qs.stringify({
              token: this.token,
              solutionSvrPoints: JSON.stringify(nlst),
              //								id
            })
          )
          .then((res) => {
            console.log(res);
            if (res.data.msg == "ok") {
              this.$message({
                message: this.langtrans().tjjjdcg[this.languageIndex],
                type: "success",
              });
              this.getNodeData();
            }
            window.location.reload();
          });
      } else {
        Message.error(this.langtrans().qbbfyy[this.languageIndex]);
      }
    },
    upnode1(i) {
      if (this.nodelist[this.nodelist.length - 1].description != "") {
        this.nodeArr = [...this.nodeArr, ...this.nodelist];
      }
      if (this.nodeArr.length == 0) {
        this.nodeArr = this.nodelist;
      }
      var btn = false;
      this.nodeArr.forEach((item) => {
        if (item.description == "") {
          btn = true;
        }
      });
      if (btn)
        return Message.error(this.langtrans().jjddmc[this.languageIndex]);
      let nlst = this.nodeArr.slice();
      if (nlst.length < 10) {
        this.axios
          .post(
            constants.domain + "rescue/case/create_svr_point",
            qs.stringify({
              token: this.token,
              solutionSvrPoints: JSON.stringify(nlst),
            })
          )
          .then((res) => {
            if (res.data.msg == "ok") {
              this.$message({
                message: this.langtrans().tjjjdcg[this.languageIndex],
                type: "success",
              });
            }
            window.location.reload();
          });
      } else {
        Message.error(this.langtrans().qbbfyy[this.languageIndex]);
      }
    },
    addNode(e, i) {
      let parent = e.target.parentNode;
      this.nodelist.push({
        description: "",
        solutionSvrId: this.serviceId,
      });
    },
    morenode(i) {
      this.serviceId = this.stepdata[i].obj.id;
      this.elseDialog = true;
      for (var j = 0; j < this.nodelist.length; ++j) {
        if (this.nodelist[j].solutionSvrId != this.serviceId) {
          this.nodelist = [
            {
              solutionSvrId: this.serviceId,
              description: "",
            },
          ];
          return;
        }
      }
    },
    morenode1(index) {
      //修改节点
      this.elseDialog1 = true;
      this.serviceId = this.stepdata[index].obj.id;
      this.nodeArr = this.stepdata[index].solutionSvrPointList;
      for (var j = 0; j < this.nodelist.length; ++j) {
        if (this.nodelist[j].solutionSvrId != this.serviceId) {
          this.nodelist = [
            {
              solutionSvrId: this.serviceId,
              description: "",
            },
          ];
          return;
        }
      }
    },
    upnum(val) {
      if (isNaN(val)) {
        Message.error(this.langtrans().qsrsss[this.languageIndex]); //请输入数字，而非其他
      } else {
        if (!this.jytxt) {
          this.jytxt = 0;
        }
        if (!this.yltxt) {
          this.yltxt = 0;
        }
        if (!this.ajtxt) {
          this.ajtxt = 0;
        }
        if (!this.qttxt) {
          this.qttxt = 0;
        }
        this.jytxt = this.jytxt * 1;
        this.yltxt = this.yltxt * 1;
        this.ajtxt = this.ajtxt * 1;
        this.qttxt = this.qttxt * 1;
        this.zttxt = Number(
          this.jytxt + this.yltxt + this.ajtxt + this.qttxt
        ).toFixed(2);
      }
    },
    accup() {
      let that = this;
      if (that.serviceFinish == 0) {
        Message.error(this.langtrans().qwcsyy[this.languageIndex]); //请完成所有操作！qwcsyy
        return;
      }
      if (!this.jytxt) {
        this.jytxt = 0;
      }
      if (!this.yltxt) {
        this.yltxt = 0;
      }
      if (!this.ajtxt) {
        this.ajtxt = 0;
      }
      if (!this.qttxt) {
        this.qttxt = 0;
      }
      // if(this.zttxt == 0) {
      // 	Message.error(this.langtrans().qsrje[this.languageIndex]);//请输入金额
      // 	return;
      // }
      this.axios
        .post(
          constants.domain + "rescue/case/finish",
          qs.stringify({
            token: this.token,
            id: this.caseid,
            totalFee: Number(this.zttxt).toFixed(2),
            rescueFee: Number(this.jytxt).toFixed(2),
            medicFee: Number(this.yltxt).toFixed(2),
            caseFee: Number(this.ajtxt).toFixed(2),
            otherFee: Number(this.qttxt).toFixed(2),
            otherFeeDesc: this.qt,
          })
        )
        .then((res) => {
          if (res.data.code === 0) {
            this.isacc = false;
            this.$router.push({
              name: "Finishparinf",
              params: {
                token: this.$route.token,
              },
              query: {
                typeId: this.$route.query.typeId,
                caseid: this.$route.query.caseid,
              },
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    setqt() {},
    getdata() {},
    acc() {
      if (this.serviceFinish == 0) {
        Message.error(this.langtrans().qwcsyy[this.languageIndex]); //请完成所有操作
        return;
      }
      this.isacc = true;
    },
    test() {
      let tUploadCnts = this.imglist.slice();
      console.log("test:" + JSON.stringify(tUploadCnts));
    },
    oknode() {
      let that = this;
      let tUploadCnts = this.urllist.slice();
      console.log(this.num);
      let obj = Object.assign({}, this.stepdata[this.num].obj);
      obj.tUploadCnts = JSON.stringify(tUploadCnts);
      obj.description = this.txt;
      obj.token = this.token;
      if (this.txt == "" && tUploadCnts.length == 0)
        return Message.error(this.langtrans().nrbbfn[this.languageIndex]);
      //				if(this.num != 1){
      //					if(this.stepdata[this.num-1].obj.state != 1) return Message.error("请先完成上一节点！")
      //				}
      this.axios
        .post(
          constants.domain + "rescue/case/conclude_phase",
          qs.stringify(obj)
        )
        .then((obj) => {
          console.log(obj);
          if (obj.data.msg == "ok") {
            this.$message({
              message: this.langtrans().tjcg[this.languageIndex],
              type: "success",
            });
            window.location.reload();
          }
        });
    },
    oknode1() {
      let that = this;
      console.log(this.imglistFj1);
      let tUploadCnts = this.imglistFj1.slice();
      let obj = Object.assign({}, this.stepdata[this.num1].obj);
      obj.tUploadCnts = JSON.stringify(tUploadCnts);
      obj.description = this.imglistShuoming;
      obj.token = this.token;
      this.axios
        .post(
          constants.domain + "rescue/case/conclude_phase",
          qs.stringify(obj)
        )
        .then((obj) => {
          console.log(obj);
          if (obj.data.msg == "ok") {
            this.$message({
              message: this.langtrans().tjcg[this.languageIndex],
              type: "success",
            });
            window.location.reload();
          }
        });
    },
    up() {
      let that = this;
      var reader = new FileReader();
      reader.readAsDataURL(this.file);
      let formdata = new FormData();
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      formdata.append("token", this.token);
      reader.onload = function (e) {
        console.log(that.file);
        formdata.append("file", that.file);
        that.axios
          .post(constants.domain + "rescue/case/upload_file", formdata, config)
          .then((res) => {
            that.fileurl = res.data.obj;
            that.imglist[that.num - 1].list.push(that.fileurl);
            that.urllist.push({
              url: that.fileurl,
              description: that.txts,
            });
            that.imgVisible = false;
            that.centerDialogVisible = true;
            that.txts = "";
            that.$refs.fileInput.value = "";
          });
      };
    },
    up1() {
      let that = this;
      var reader = new FileReader();
      reader.readAsDataURL(this.file);
      let formdata = new FormData();
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      formdata.append("token", this.token);
      reader.onload = function (e) {
        formdata.append("file", that.file);
        that.axios
          .post(constants.domain + "rescue/case/upload_file", formdata, config)
          .then((res) => {
            that.fileurl = res.data.obj;
            //							that.imglist[that.num1 - 1].list.push(that.fileurl);
            that.urllist.push({
              url: that.fileurl,
              description: that.txts,
            });
            that.imgVisible1 = false;
            that.centerDialogVisible1 = true;
            var arr = [];
            that.imglist[that.num1 - 1].list.forEach((item) => {
              arr.push({ url: item.url, description: item.description });
            });
            that.imglistFj1 = arr;
            that.imglistFj1 = [...that.urllist, ...that.imglistFj];
            that.txts = "";
            that.$refs.fileInput.value = "";
          });
      };
    },
    txtdata() {},
    txtsdata() {},
    filedata(e) {
      this.file = e.target.files[0];
      this.txts = this.file.name;
    },
    upimg() {
      this.imgVisible = true;
      this.centerDialogVisible = false;
    },
    upimg1() {
      this.imgVisible1 = true;
      this.centerDialogVisible1 = false;
    },
    hendnode(e) {
      console.log(e.target);
    },
    dialogImageUrl() {},
    dialogVisible() {},
    st(i) {
      this.num = i;
      this.id = this.stepdata[i].obj.serviceId;
      this.centerDialogVisible = true;
    },
    st1(i) {
      this.num1 = i;
      this.imglistFj = this.imglist[i - 1].list;
      this.imglistFj1 = this.imglistFj;
      this.imglistShuoming = this.stepdata[i].obj.description;
      this.centerDialogVisible1 = true;
    },
    back() {
      this.$router.push({
        name: "Rescue",
        params: {
          token:
            this.$route.params.token ||
            JSON.parse(window.localStorage.getItem("data")).data,
        },
        query: {
          typeId: this.$route.query.typeId,
        },
      });
    },
    getNodeData() {
      var data = {
        token: this.token,
        caseId: this.caseid,
      };
      getNodeData(data).then((res) => {
        this.flag = true;
        this.feedata = res.data.obj;
        this.stepdata = res.data.obj2;
        let n = 0;
        let arr = [];
        this.stepdata.map((v, i) => {
          arr.push(v.obj.state);
          if (v.dict.parentId != 0) {
            if (v.obj.state && v.obj.state == 1) {
              this.stid = i;
              console.log(v.obj.state);
            } else {
              this.serviceFinish = 0;
            }
          }
          if (i != 0) {
            this.imglist.push({
              list: v.uploadCntList,
            });
            if (v.uploadCntList.length > 0) {
              this.num = i;
            }
          }
        });
        for (let index = 0; index < arr.length; index++) {
          if (arr[index] != 0) {
          } else {
            n = index + 1;
          }
        }
        if (n == 0) {
          this.btn_flag = true;
        }
        this.loading = false;
      });
    },
    deleteNode(i) {
      this.nodeArr.splice(i, 1);
    },
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
  },
  mounted() {
    this.getNodeData();
    this.getdetailCase();
    // if(this.$route.query.typeId == 800) {
    //   this.ajtxt = 70;
    //   this.zttxt = 70
    // }
  },
};
</script>

<style scoped>
@import url("../../css/resstep.css");
.jiedianBox {
  margin-left: 50px;
  margin-top: 20px;
}
.jiedianBox .list {
  margin-bottom: 20px;
}
.jiedianBox .list .top {
  overflow: hidden;
}
.jiedianBox .list .top p {
  float: left;
  margin-right: 200px;
}
.jiedianBox .list .top p.text1 {
  color: #00abfa;
  margin-right: 0;
  margin-left: 20px;
  cursor: pointer;
}
.jiedianBox .list .top p.icon {
  background: url("./../../assets/img/checkyes.png") left center no-repeat;
  padding-left: 20px;
  background-size: 16px;
  min-width: 250px;
}
.jiedianBox .list .top p.iconNo {
  background: url("./../../assets/img/checkno.png") left center no-repeat;
  padding-left: 23px;
  background-size: 16px;
  min-width: 250px;
}
.jiedianBox .list .box1 {
  margin-top: 10px;
  margin-left: 30px;
  overflow: hidden;
}
.jiedianBox .list .box1 ul {
  float: left;
  color: #999;
}
.jiedianBox .list .box1 p {
  float: left;
  line-height: 30px;
}
.jiedianBox .list .box1 li {
  line-height: 30px;
}
.addfujian li {
  background: url("../../../static/images/fj.png") no-repeat left center;
  padding-left: 20px;
  cursor: pointer;
  margin-bottom: 10px;
  line-height: 30px;
  margin-right: 150px;
}
.addfujian li span {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}
.addfujian li.add {
  color: #00abfa;
}
.addfujian li .delete {
  color: #00abfa;
  margin-left: 10px;
  text-decoration: none;
}
.node {
  margin-bottom: 10px;
}
.el-dialog.el-dialog--center ul {
  overflow: hidden;
}
.el-dialog.el-dialog--center ul {
  margin-top: 10px;
}
.el-dialog.el-dialog--center ul li {
  float: left;
  margin-right: 10px;
}
.el-dialog.el-dialog--center ul li img {
  width: 60px;
  height: 60px;
}
.el-dialog.el-dialog--center ul li p {
  text-align: center;
  line-height: 30px;
}
.el-dialog.el-dialog--center ul li .text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.acc_box .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
}
.acc_box .el-dialog__body {
  padding-top: 0 !important;
}
.text_1 {
  font-size: 16px;
}
.text_1 span {
  margin-right: 40px;
}
.p_box {
  overflow: hidden;
}
.p_box input {
  padding-left: 10px;
  outline: none;
  height: 25px;
  width: 200px;
}
.p_box label {
  position: relative;
}
.p_box label span {
  position: absolute;
  right: 5px;
  top: 5px;
}
.p_box label.input span {
  position: static;
}
label.input p {
  display: inline-block;
  padding-right: 10px;
}
.input_box {
  display: inline-block;
}
.newText {
  margin: 15px 0;
  margin-left: 40px;
}
.newText span {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/fac/resstep.vue